"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FelaText = exports.ruleKeysFelaText = exports.FelaRuleText = exports.heavierWeightFrom = exports.weightToTextWeightType = exports.ETextTag = void 0;
const react_1 = __importDefault(require("react"));
const FelaCache_1 = require("../../fela/FelaCache");
const VibescoutFrontendStyleConfig_1 = require("../config/VibescoutFrontendStyleConfig");
const FelaCommon_1 = require("./FelaCommon");
var ETextTag;
(function (ETextTag) {
    ETextTag["h1"] = "h1";
    ETextTag["h2"] = "h2";
    ETextTag["h3"] = "h3";
    ETextTag["h4"] = "h4";
    ETextTag["h5"] = "h5";
    ETextTag["p"] = "p";
    ETextTag["label"] = "label";
    ETextTag["div"] = "div";
    ETextTag["span"] = "span";
})(ETextTag || (exports.ETextTag = ETextTag = {}));
exports.weightToTextWeightType = {
    black: VibescoutFrontendStyleConfig_1.ETextWeightType.black,
    bold: VibescoutFrontendStyleConfig_1.ETextWeightType.bold,
    light: VibescoutFrontendStyleConfig_1.ETextWeightType.light,
    regular: VibescoutFrontendStyleConfig_1.ETextWeightType.regular,
    normal: VibescoutFrontendStyleConfig_1.ETextWeightType.regular,
    500: VibescoutFrontendStyleConfig_1.ETextWeightType.regular,
    300: VibescoutFrontendStyleConfig_1.ETextWeightType.light,
    700: VibescoutFrontendStyleConfig_1.ETextWeightType.bold,
    900: VibescoutFrontendStyleConfig_1.ETextWeightType.black,
};
exports.heavierWeightFrom = {
    [VibescoutFrontendStyleConfig_1.ETextWeightType.light]: VibescoutFrontendStyleConfig_1.ETextWeightType.regular,
    [VibescoutFrontendStyleConfig_1.ETextWeightType.regular]: VibescoutFrontendStyleConfig_1.ETextWeightType.bold,
    [VibescoutFrontendStyleConfig_1.ETextWeightType.bold]: VibescoutFrontendStyleConfig_1.ETextWeightType.black,
    [VibescoutFrontendStyleConfig_1.ETextWeightType.black]: VibescoutFrontendStyleConfig_1.ETextWeightType.black,
};
const FelaRuleText = ({ neutralColor, color, colorHex, opacity, block, theme, typography = VibescoutFrontendStyleConfig_1.ETextTypographyType.sansSerif, transform, size, wordBreak, 
// style,
weight, spacing, lineHeight, align, contrast = FelaCommon_1.EGraphicContrast.MID, fontSize, margin = 0, whiteSpace = "pre-line", decoration, forceTheme, overflowWrap, }) => {
    const fontWeight = exports.weightToTextWeightType[weight ?? VibescoutFrontendStyleConfig_1.ETextWeightType.regular];
    let colorProp;
    const foreContrast = FelaCommon_1.contrastToFore[contrast];
    if (spacing === undefined) {
        spacing =
            typography === VibescoutFrontendStyleConfig_1.ETextTypographyType.inherit
                ? undefined
                : theme.styles.Font.defaultSpacing[typography];
    }
    if (lineHeight === undefined) {
        lineHeight =
            typography === VibescoutFrontendStyleConfig_1.ETextTypographyType.inherit
                ? undefined
                : theme.styles.Font.defaultLineHeight[typography];
    }
    if (neutralColor) {
        colorProp =
            opacity == null
                ? theme.styles.Themes[forceTheme ?? theme.currentId].RgbColors.neutral[neutralColor]
                : `rgba(${theme.styles.Themes[forceTheme ?? theme.currentId].Colors.neutral[neutralColor][0]}, ${opacity}})`;
    }
    else if (color !== undefined) {
        colorProp = opacity == null ? `rgb(${color[0]})` : `rgba(${color[0]}, ${opacity})`;
    }
    else {
        if (colorHex !== undefined) {
            colorProp = colorHex;
        }
        else {
            // default high-contrast
            colorProp =
                opacity == null
                    ? theme.styles.Themes[forceTheme ?? theme.currentId].RgbColors.fore[foreContrast]
                    : `rgba(${theme.styles.Themes[forceTheme ?? theme.currentId].Colors.fore[foreContrast][0]}, ${opacity})`;
            /*colorProp = theme.dark ? theme.styles.RgbColors.darkFore.lig : theme.styles.RgbColors.lightFore.dar;
      
            if (contrast === EGraphicContrast.MID) {
              colorProp = theme.dark ? theme.styles.RgbColors.darkFore.mid : theme.styles.RgbColors.lightFore.mid;
            } else if (contrast === EGraphicContrast.LOW) {
              colorProp = theme.dark ? theme.styles.RgbColors.darkFore.dar : theme.styles.RgbColors.lightFore.lig;
            }*/
        }
    }
    return {
        "& b": {
            fontWeight: theme.styles.Font.weights[typography][exports.heavierWeightFrom[fontWeight]],
        },
        "& i": {
            fontStyle: theme.styles.Font.italicStyleType[typography],
        },
        "& code": {
            fontFamily: theme.styles.Font.family[VibescoutFrontendStyleConfig_1.ETextTypographyType.mono],
        },
        "& sub": {
            verticalAlign: "sub",
            fontSize: "smaller",
        },
        fontFamily: typography === VibescoutFrontendStyleConfig_1.ETextTypographyType.inherit ? "inherit" : theme.styles.Font.family[typography],
        fontSize: fontSize
            ? fontSize
            : size
                ? theme.styles.Font.sizes[size]
                : theme.styles.Font.sizes[VibescoutFrontendStyleConfig_1.ETextSize.content],
        color: colorProp,
        display: block ? "block" : "inline-block",
        textTransform: transform,
        // fontWeight: weight as FontFaceFontWeightProperty,
        fontWeight: typography === VibescoutFrontendStyleConfig_1.ETextTypographyType.inherit
            ? "inherit"
            : theme.styles.Font.weights[typography][fontWeight],
        // fontStyle: style,
        letterSpacing: spacing,
        textAlign: align,
        textDecoration: decoration,
        overflowWrap,
        lineHeight,
        margin,
        whiteSpace,
        wordBreak,
    };
};
exports.FelaRuleText = FelaRuleText;
exports.ruleKeysFelaText = [
    "neutralColor",
    "opacity",
    "color",
    "colorHex",
    "block",
    "typography",
    "transform",
    "size",
    "weight",
    "spacing",
    "lineHeight",
    "align",
    "contrast",
    "fontSize",
    "margin",
    "whiteSpace",
    "decoration",
    "forceTheme",
    "overflowWrap",
];
const FelaText = ({ children, cssExtra = [], style, rootProps, id, onClick, ...props }) => {
    // const { css } = useFela(props);
    const { inlineCss, cachedClass } = (0, FelaCache_1.useFelaCache)();
    const { tag = ETextTag.p } = props;
    return react_1.default.createElement(tag, {
        style,
        id,
        onClick,
        className: /*`text ${css(FelaRuleText, ...cssExtra)}`*/ `text ${cachedClass(exports.FelaRuleText, props, exports.ruleKeysFelaText)} ${inlineCss(cssExtra)}`,
        ...rootProps,
    }, children);
};
exports.FelaText = FelaText;
